import { writable } from "svelte/store";
export function createLocalStorageStore(key, def) {
    const store = writable(localStorage.getItem(key) || def);
    return {
        subscribe: (subscriber, invalidate) => store.subscribe(subscriber, invalidate),
        set: (state) => {
            store.set(state);
            localStorage.setItem(key, state);
        },
    };
}
